










































































































	// import Transactions from '../transaction/ProductTransactions';
	import {
		Instance
	} from '@/classes/TayehApi';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

	@Component({
		computed: {
			...mapGetters(['update_inventory']),
		},
		components: {
			'image-view': () => import('@/components/ImageView.vue')
		}
	})
	export default class ShopInventoryProductTable extends Vue {
		@Prop() private instance: number;
		
		products: any[] = [];
		new_product: any = {};
		count = 0;
		per_page = 20;
		loading = false;
		page = 1;
		new_key = 0;
		search = '';

		@Watch('update_inventory')
		inventory_updated () {			
			this.page = 1;
			this.getProducts(1)
		}
	
		async getProducts(page = this.page) {			
			this.products = [];
			this.loading = true;
			const {
				objects,
				count
			} = (await Instance.getProducts(this.instance, {per_page: this.per_page, page: page-1, search: this.search})).data
			this.products = objects;
			this.count = count;
		}

		// create_new () {
		// 	this.new_key++;
		// 	this.products.push({id: null, name: 'نام محصول', description: 'توضیحات', new_key: this.new_key});
		// },
		// cancel_new (product) {
		// 	const i = this.products.map (e => {return e.new_key}).indexOf(product.new_key)
		// 	if (i !== -1) this.products.splice(i, 1);
		// },
		// async create(product: any) {
		// 	Instance.createProduct
		// 	let res = await Cirus.post(
		// 		`/instance/${this.instance}/product`,
		// 		product,
		// 	)
		// 	if (res.data.err) {
		// 		this.$message({
		// 			showClose: true,
		// 			message: res.data.err,
		// 			type: 'error',
		// 			duration: 5000
		// 		});
		// 	} else {
		// 		// const i = this.products.map(e => {
		// 		// 	return e.new_key;
		// 		// }).indexOf(product.new_key)
		// 		// if (i !== -1) this.products[i] = res.data.product;
		// 		this.getProducts();
		// 		this.$message({
		// 			showClose: true,
		// 			message: 'محصول ذخیره شد.',
		// 			type: 'success',
		// 			duration: 5000
		// 		});
		// 	}
		// }

		gotoProduct() {
			// this.$router.push(`/products/${product.id}/transactions/`);
		}

		async askForDelete(product: any) {
			try {
				await this.$confirm(`آیا میخواهید محصول "${product.name}" را حذف کنید؟`, {
					title: 'حذف محصول',
					confirmButtonText: 'بله',
					cancelButtonText: 'خیر'
				})
				this.deleteProduct(product.id);
			} catch (err) {
				return;
			}
		}

		async deleteProduct(id: string) {
			this.loading = true;
			try {
				await Instance.deleteProduct(this.instance, id);
				this.$message({
					showClose: true,
					message: 'محصول با موفقیت حذف شد.',
					type: 'success',
					duration: 5000
				});
				this.getProducts()
			} catch (err) {
				this.$message({
					showClose: true,
					message: 'لطفا دوباره تلاش کنید.',
					type: 'error',
					duration: 10000
				});
			} finally {
				this.loading = false;
			}
		}

		// async update(product: any) {
		// 	this.loading = true;
		// 	const res = (await Cirus.post(
		// 		`/instance/${this.instance}/product/update/`,
		// 		product
		// 	)).data;
		// 	if (res.err) {
		// 		this.$message({
		// 			showClose: true,
		// 			message: res.err,
		// 			type: 'error',
		// 			duration: 5000
		// 		});
		// 	} else {
		// 		this.$message({
		// 			showClose: true,
		// 			message: res.response,
		// 			type: 'success',
		// 			duration: 5000
		// 		});
		// 	}
		// 	this.loading = false;
		// }
		tableRowClassName(obj: any) {
			if (obj.row.id == null) {
				return 'success-row';
			}
			// else if (row.stock_quantity <= 1) {
			//   return 'danger-row';
			// }
			return '';
		}
		// spanMethod({
		// 	row,
		// 	columnIndex
		// }: {row: }) {
		// 	if (!row.id) {
		// 		if (columnIndex === 0)
		// 			return [0, 0]
		// 		else if (columnIndex === 1)
		// 			return [1, 2]
		// 		else if (columnIndex === 3)
		// 			return [1, 2]
		// 		else if (columnIndex === 4)
		// 			return [0, 0]
		// 	}
		// 	return [1, 1]
		// }
		mounted() {
			this.getProducts();
		}
	}
